import React from "react";
import { routes } from "utilities/routing/generatedRoutes";
import ConfirmCopyModal from "components/modals/ConfirmCopyModal";

interface Props {
  mainArea: server.dto.MainAreas
  tag: server.dto.TagSmall
  isOpen: boolean
  onClose: () => void
}

const ConfirmCopyTagModal = (props: Props) => {
  const apiCall = async () => {
    const response = await window.CoreApi.Tag.Copy(props.tag.tagId);
    return response.data;
  };

  return <ConfirmCopyModal
    isOpen={props.isOpen}
    apiCall={apiCall}
    onClose={props.onClose}
    onSuccess={(itemId) => window.location.href = routes.tag_Detail(itemId).absolute}
  />;
};

export default ConfirmCopyTagModal;